import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import {
  Avatar,
  Card,
  Grid,
  Box,
  Divider,
  CardContent,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  makeStyles
} from '@material-ui/core';
import { LocationCity, MoreVert as MoreVertIcon } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    width: 'auto',
    height: 'auto'
  },
}));

const StateCard = ({ className, state, ...rest }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [menuIsOpen, setMenuIsOpen] = useState(null);

  const toggleMenu = (e) => setMenuIsOpen(!menuIsOpen ? e.currentTarget : null);

  const redirect = () => {
    navigate(`/app/estados/${state.id}/editar`, { replace: true });
    toggleMenu();
  };

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item xs={3} direction="column" justify="center" alignItems="center">
            <Avatar
              className={classes.avatar}
              alt="state"
              src={state?.country?.flag}
              variant="square"
            />
          </Grid>
          <Grid container item xs={9} alignItems="flex-start">
            <Grid container item xs={10} alignItems="flex-start">
              <Box mt={1}>
                <Typography
                  align="left"
                  color="textPrimary"
                  gutterBottom
                  variant="h4"
                >
                  {state.name}
                </Typography>
                <Typography
                  align="left"
                  color="textPrimary"
                  gutterBottom
                  variant="caption"
                >
                  {state?.country?.name}
                </Typography>
              </Box>
            </Grid>
            <Grid container item xs={2} alignItems="flex-start">
              <IconButton onClick={toggleMenu}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={menuIsOpen}
                open={Boolean(menuIsOpen)}
                onClose={toggleMenu}
              >
                <MenuItem onClick={() => redirect('edit')}>Editar</MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <Box p={2}>
        <Grid item container justify="flex-end" alignItems="center">
          <Box mr={1}>
            <LocationCity color="action" />
          </Box>
          <Typography color="textSecondary" display="inline" variant="body2">
            {state?.cities?.length || 0}
            {' '}
            {state?.cities?.length === 1 ? 'ciudad' : 'ciudades'}
          </Typography>
        </Grid>
      </Box>
    </Card>
  );
};

StateCard.propTypes = {
  className: PropTypes.func,
  state: PropTypes.object.isRequired
};

StateCard.propTypes = {
  className: () => {},
};

export default StateCard;
